import { AccordionCloseIcon, AccordionOpenIcon } from "src/components/MegaMenu/svgIcons"

export const AccordionComponent = (props : any) => {
    const {headingComp, contentComp, isOpen, setIsOpen,  color} = props
    return (
       <div className="tw-w-[100%] tw-flex tw-flex-col tw-gap-[16px]">
          <div onClick={setIsOpen} className="tw-flex tw-items-center tw-justify-between">
              {<div className="tw-cursor-pointer">{headingComp()}</div>}
              {
                  isOpen ? (
                    <AccordionCloseIcon
                      secondaryColor={color}
                    />
                  ) : (
                    <AccordionOpenIcon
                      secondaryColor={color}
                    />
                  )
                }
          </div>
          {isOpen && <div>{contentComp()}</div>}
       </div>
    )
}